import { SVGProps } from 'react';

export function TagIcon(props: SVGProps<SVGSVGElement>) {
  const { height = '16', width = '16', color = '#fff', ...rest } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_9081_73"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_9081_73)">
        <path
          d="M6.56727 19.5385L7.56727 15.5385H3.75977L4.13477 14.0385H7.94227L8.96152 9.9615H5.15402L5.52902 8.4615H9.33652L10.3365 4.4615H11.8173L10.8173 8.4615H14.952L15.952 4.4615H17.4328L16.4328 8.4615H20.2403L19.8653 9.9615H16.0578L15.0385 14.0385H18.846L18.471 15.5385H14.6635L13.6635 19.5385H12.1828L13.1828 15.5385H9.04802L8.04802 19.5385H6.56727ZM9.42302 14.0385H13.5578L14.577 9.9615H10.4423L9.42302 14.0385Z"
          fill="#2E2E2E"
        />
      </g>
    </svg>
  );
}
